import Vue from 'vue'
import vuex from 'vuex'
import globalStore from '../vuex/global'
Vue.use(vuex)

export default new vuex.Store({
  strict: process.env.NODE_ENV !== 'production',
  modules: {
    global: globalStore
  }
})
